<template>
    <!-- pricing Section -->
	<section class="price-sections-seven">
		<div class="container">
			<div class="row">
				<div class="col-md-12 text-center">
					<div class="section-heading section-heading-seven aos" data-aos="fade-up">
						<h2>Pricing Plan</h2>
						<p>Designed to effectively communicate your service offerings and their associated costs</p>
					</div>
				</div>
			</div>
			<div class="price-toggle price-toggle-seven text-center mb-0">
				<div class="status-toggle toggle-pink d-inline-flex align-items-center">
					Bill Monthly
					<input type="checkbox" id="status_1" class="check">
					<label for="status_1" class="checktoggle mx-3">checkbox</label>
					Bill Annualy
				</div>
			</div>
			<div class="row aos" data-aos="fade-up">
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new pricing-plans-seven">
						<div class="pricing-plans-img">
							<img src="@/assets/img/icons/pricing-seven-3.svg" alt="image">
						</div>
						<div class="pricing-planshead">
							<h5>Basic</h5>
							<h6><span>$</span>10.00</h6>
						</div>
						<div class="pricing-planscontent pricing-planscontent-seven">
							<ul>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>1 Bathroom cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Up to 3 bedrooms cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Full Furnished Room Cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Additional 05 Rooms</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Small kitchen (0 - 150 ft2)</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view w-100">Choose Plan</router-link>
							</div>
							<div class="price-bg">
								<img src="@/assets/img/bg/price-bg-vector.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new pricing-plans-seven active-seven">
						<div class="price-block">
							<span class="popular">MOST POPULAR</span>
						</div>
						<div class="pricing-plans-img">
							<img src="@/assets/img/icons/pricing-seven-2.svg" alt="image">
						</div>
						<div class="pricing-planshead">
							<h5>Standard </h5>
							<h6><span>$</span>90.99</h6>
						</div>
						<div class="pricing-planscontent pricing-planscontent-seven">
							<ul>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>1 Bathroom cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Up to 3 bedrooms cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Full Furnished Room Cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Additional 05 Rooms</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Small kitchen (0 - 150 ft2)
									</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view w-100">Choose Plan</router-link>
							</div>
							<div class="price-bg">
								<img src="@/assets/img/bg/price-bg-vector.png" alt="">
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-4 col-sm-12">
					<div class="pricing-plans price-new pricing-plans-seven">
						<div class="pricing-plans-img">
							<img src="@/assets/img/icons/pricing-seven-1.svg" alt="image">
						</div>
						<div class="pricing-planshead">
							<h5>Basic</h5>
							<h6><span>$</span>150.99</h6>
						</div>
						<div class="pricing-planscontent pricing-planscontent-seven">
							<ul>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Upto 5 Bathroom Cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Upto 10 bedrooms Cleaning
									</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Full Furnished Rooms 15 sqft Cleaning</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Additional 16 Rooms</span>
								</li>
								<li>
									<i class="fa fa-check me-2"></i>
									<span>Small kitchen (0 - 150 ft2)
									</span>
								</li>
							</ul>
							<div class="pricing-btn">
								<router-link to="/service/search" class="btn btn-view w-100">Choose Plan</router-link>
							</div>
							<div class="price-bg">
								<img src="@/assets/img/bg/price-bg-vector.png" alt="">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- /pricing Section -->


		<!-- Testimonials Section -->
		<section class="testimonals-seven-section pt-0">
			<div class="container">
				<div class="section-heading section-heading-seven">
					<div class="row">
						<div class="col-md-6 aos" data-aos="fade-up">
							<h2>Testimonials</h2>
							<p>Description highlights the value of client feedback, showcases real testimonials</p>
						</div>
						<div class="col-md-6 text-md-end aos" data-aos="fade-up">
							<div class="owl-nav mynav-test"></div>
						</div>
					</div>
				</div>
				<div class="row align-items-center">
					<div class="col-lg-6 col-12">
						<div class="testimonals-top-seven">
							<img src="@/assets/img/testimonial-map.svg" alt="image">
						</div>
					</div>
					<div class="col-lg-6 col-12">
						<div class="owl-carousel testimonals-seven-slider">
                            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
							    <Slide v-for="item in indexseventestimonial" :key="item.id">
                                    <div class="testimonials-main-ryt">
										<div class="testimonials-content-seven">
											<div class="testimonials-seven-img">
												<img :src="require(`@/assets/img/profiles/${item.avatar}`)" alt="User">
												<div class="testimonials-img-content text-start">
													<h6>James Williams</h6>
													<div class="rating">
														<i class="fas fa-star filled me-1"></i>
														<i class="fas fa-star filled me-1"></i>
														<i class="fas fa-star filled me-1"></i>
														<i class="fas fa-star filled me-1"></i>
														<i class="fas fa-star filled me-1"></i>
													</div>
												</div>
											</div>
											<img src="@/assets/img/icons/test-quote.svg" alt="image" class="img-fluid">
										</div>
										<p class="text-start">
											{{item.content}}
										</p>
									</div>
                                </Slide>
                                    <template #addons>
                                        <Navigation />
                                    </template>
                            </Carousel>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- /Testimonials Section -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexseventestimonial from '@/assets/json/indexseventestimonial.json'
import "vue3-carousel/dist/carousel.css";
export default {
	data() {
		return {
			indexseventestimonial: indexseventestimonial,
			settings: {
				itemsToShow: 1,
				snapAlign: "center",
				loop: true,
				margin: 24,
			},

			breakpoints: {
				575: {
					itemsToShow: 1,
					snapAlign: "center"
				},
				// 700px and up
				767: {
					itemsToShow: 1,
					snapAlign: "center"
				},
				// 991px and up
				991: {
					itemsToShow: 1,
					snapAlign: "center"
				},
				// 1024 and up
				1024: {
					itemsToShow: 1,
					snapAlign: "start"

				}
			}
		}
	},
	components: {
		Carousel,
		Slide,
		Pagination,
		Navigation,
	},
}
</script>